import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 2560.000000 2560.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,2560.000000) scale(0.100000,-0.100000)">

<path d="M12190 24275 c-140 -7 -279 -16 -310 -19 -30 -3 -127 -13 -215 -21
-908 -85 -1957 -325 -2815 -642 -178 -66 -490 -191 -590 -236 -30 -14 -104
-46 -165 -72 -274 -118 -774 -375 -1092 -561 -378 -221 -852 -535 -1137 -754
-86 -66 -411 -325 -443 -353 -15 -14 -66 -57 -113 -97 -245 -210 -466 -418
-735 -691 -284 -290 -494 -526 -754 -849 -51 -63 -98 -122 -104 -130 -7 -8
-23 -31 -37 -50 -13 -19 -27 -37 -30 -40 -5 -4 -56 -73 -190 -255 -389 -528
-831 -1291 -1134 -1957 -74 -162 -97 -216 -193 -453 -95 -235 -224 -589 -278
-765 -13 -41 -37 -118 -53 -170 -192 -604 -372 -1478 -436 -2125 -9 -88 -21
-203 -26 -255 -28 -278 -35 -463 -34 -990 0 -418 5 -609 17 -775 109 -1447
427 -2699 1021 -4019 264 -585 716 -1362 1109 -1906 161 -222 444 -591 476
-620 4 -3 40 -45 81 -95 41 -49 77 -92 80 -95 3 -3 39 -43 80 -90 255 -291
610 -651 906 -920 607 -552 1371 -1102 2079 -1496 28 -15 97 -54 155 -86 110
-62 579 -298 665 -335 28 -12 86 -38 130 -58 570 -260 1424 -550 2003 -680 59
-13 176 -40 259 -59 351 -82 941 -174 1383 -216 1158 -111 2477 -22 3590 241
249 59 299 72 515 131 430 117 1018 318 1355 463 30 13 105 45 165 71 61 25
161 71 224 100 62 30 115 54 118 54 6 0 376 186 463 233 656 352 1293 772
1830 1207 139 112 353 291 370 310 3 3 43 39 90 80 137 121 222 202 450 430
296 296 378 384 635 685 158 184 259 310 387 480 217 290 291 394 424 595 94
142 147 227 314 500 46 75 184 319 245 430 69 129 283 557 312 625 12 28 51
118 88 200 172 387 362 903 485 1320 256 866 398 1654 462 2565 17 247 17
1198 0 1460 -25 376 -80 848 -138 1180 -8 47 -24 135 -34 195 -11 61 -40 203
-65 317 -200 926 -500 1791 -913 2638 -104 211 -288 561 -324 612 -10 14 -18
29 -18 32 0 3 -59 104 -132 223 -310 513 -667 1017 -997 1409 -14 17 -44 52
-66 79 -328 403 -939 1014 -1380 1380 -66 55 -129 107 -140 116 -221 186 -564
439 -875 646 -177 118 -584 373 -595 373 -3 0 -33 17 -67 38 -169 104 -721
390 -883 459 -27 12 -88 39 -135 61 -319 149 -858 356 -1255 480 -732 231
-1612 410 -2330 476 -93 9 -186 18 -205 21 -19 3 -178 12 -354 20 -370 17
-815 17 -1176 0z m1405 -1019 c1377 -105 2674 -466 3920 -1088 110 -55 229
-116 265 -136 217 -117 502 -283 590 -342 30 -21 120 -79 200 -131 140 -90
325 -218 440 -303 59 -44 352 -270 385 -298 377 -311 499 -422 820 -743 191
-190 249 -251 395 -411 132 -145 391 -456 511 -614 35 -47 66 -87 69 -90 26
-23 336 -468 436 -625 497 -778 888 -1611 1168 -2485 266 -832 406 -1569 478
-2520 17 -225 17 -1100 0 -1335 -28 -387 -88 -888 -138 -1150 -111 -586 -229
-1051 -376 -1480 -11 -33 -40 -118 -64 -188 -24 -70 -55 -158 -70 -195 -83
-213 -172 -431 -230 -560 -36 -81 -75 -167 -86 -192 -120 -269 -478 -931 -599
-1107 -16 -23 -29 -44 -29 -48 0 -3 -4 -11 -10 -18 -5 -7 -59 -86 -119 -177
-194 -295 -344 -501 -556 -765 -66 -82 -124 -155 -130 -161 -5 -6 -32 -37 -60
-70 -301 -353 -729 -789 -1060 -1079 -44 -39 -82 -72 -85 -76 -9 -10 -305
-254 -375 -310 -370 -292 -829 -601 -1265 -851 -264 -152 -793 -416 -1035
-518 -93 -39 -195 -82 -225 -95 -241 -105 -824 -304 -1155 -395 -1186 -326
-2405 -442 -3615 -345 -337 27 -433 38 -760 86 -1024 150 -2146 505 -3095 981
-796 399 -1484 854 -2124 1404 -654 562 -1230 1185 -1709 1850 -140 196 -462
682 -462 699 0 2 -24 44 -54 93 -214 351 -472 868 -663 1332 -315 760 -540
1560 -668 2368 -149 946 -166 1947 -50 2912 163 1348 598 2670 1278 3880 277
494 598 967 962 1417 134 165 180 220 320 378 158 179 566 596 730 745 147
134 172 157 245 220 41 36 80 70 86 75 6 6 30 26 54 45 24 19 48 40 54 45 32
31 235 190 411 322 322 242 760 529 1080 708 170 95 274 150 465 245 1183 593
2372 939 3685 1074 77 8 230 19 340 26 110 6 220 12 245 14 122 10 1050 -4
1235 -18z"/>
<path d="M12440 23050 c-253 -9 -442 -19 -495 -26 -22 -3 -139 -17 -260 -30
-121 -14 -254 -29 -295 -34 -96 -11 -279 -42 -450 -75 -74 -15 -157 -30 -185
-35 -80 -14 -227 -46 -265 -58 -19 -5 -80 -20 -135 -32 -55 -12 -107 -25 -115
-28 -8 -3 -53 -15 -100 -28 -121 -32 -272 -75 -295 -84 -11 -5 -47 -16 -80
-25 -33 -9 -68 -21 -77 -26 -10 -5 -29 -9 -42 -9 -14 0 -27 -4 -30 -9 -3 -5
-16 -11 -28 -14 -25 -5 -251 -83 -283 -96 -11 -5 -36 -14 -55 -21 -38 -14
-203 -77 -235 -91 -11 -5 -44 -18 -74 -29 -30 -12 -73 -29 -95 -39 -23 -11
-70 -31 -106 -46 -36 -15 -92 -39 -125 -55 -157 -73 -195 -90 -205 -90 -5 0
-10 -4 -10 -10 0 -5 -7 -10 -15 -10 -15 0 -389 -188 -475 -239 -52 -30 -114
-64 -150 -83 -14 -6 -49 -27 -78 -45 -29 -18 -55 -33 -58 -33 -3 0 -36 -19
-72 -43 -37 -23 -89 -56 -117 -72 -54 -31 -537 -348 -564 -371 -9 -7 -72 -54
-141 -104 -115 -85 -338 -257 -350 -270 -3 -3 -25 -21 -50 -40 -42 -32 -113
-92 -254 -214 -32 -27 -64 -55 -70 -61 -6 -5 -85 -78 -176 -162 -157 -144
-407 -393 -535 -533 -80 -86 -205 -226 -243 -270 -203 -237 -283 -337 -469
-585 -129 -173 -343 -481 -343 -495 0 -5 -3 -10 -7 -12 -17 -7 -393 -623 -393
-643 0 -1 -16 -32 -36 -67 -38 -67 -304 -592 -304 -601 0 -3 -18 -44 -40 -91
-22 -47 -40 -88 -40 -90 0 -3 -13 -33 -29 -68 -16 -35 -48 -110 -71 -168 -23
-58 -48 -118 -55 -135 -25 -58 -113 -302 -159 -440 -26 -77 -51 -149 -56 -160
-4 -11 -11 -29 -13 -40 -3 -11 -17 -58 -32 -105 -15 -47 -31 -98 -35 -115 -5
-16 -18 -64 -30 -105 -26 -91 -68 -250 -80 -305 -6 -22 -19 -78 -30 -125 -31
-127 -71 -308 -81 -365 -4 -27 -20 -113 -34 -190 -44 -248 -60 -345 -75 -475
-4 -41 -13 -113 -19 -160 -6 -47 -15 -150 -21 -230 -6 -80 -15 -167 -20 -195
-5 -27 -13 -176 -17 -330 -16 -566 5 -1140 58 -1580 6 -49 14 -121 19 -160 10
-90 42 -291 75 -475 14 -80 30 -167 35 -195 12 -69 56 -268 73 -335 8 -30 20
-82 27 -115 6 -33 16 -69 20 -80 5 -11 14 -45 21 -75 6 -30 17 -73 24 -95 7
-22 22 -78 35 -125 12 -47 26 -92 30 -102 5 -9 16 -45 25 -80 9 -34 19 -72 24
-83 5 -11 29 -85 55 -165 26 -80 51 -153 57 -162 5 -10 9 -26 9 -36 0 -10 4
-22 8 -27 4 -6 14 -28 21 -50 16 -46 78 -210 91 -240 5 -11 19 -45 31 -75 11
-30 27 -68 34 -85 7 -16 35 -79 61 -140 144 -335 393 -827 559 -1105 18 -30
61 -102 96 -160 78 -132 333 -519 412 -625 32 -44 66 -91 75 -104 141 -200
495 -632 706 -861 268 -290 691 -697 930 -895 27 -22 54 -45 60 -51 122 -114
829 -638 936 -694 14 -7 27 -16 30 -19 6 -8 223 -145 310 -196 36 -21 82 -49
103 -62 43 -27 77 -47 174 -99 37 -20 73 -40 78 -44 31 -23 616 -320 629 -320
3 0 54 -22 112 -50 58 -27 108 -50 110 -50 2 0 26 -10 52 -21 94 -42 112 -50
214 -90 57 -22 112 -44 123 -49 11 -5 79 -30 150 -55 72 -26 139 -50 150 -55
47 -19 407 -136 500 -162 80 -22 108 -30 185 -52 103 -30 295 -78 450 -113
244 -55 283 -63 308 -63 12 0 30 -4 40 -9 9 -6 94 -21 187 -36 94 -14 193 -30
220 -35 28 -5 93 -15 145 -20 52 -6 136 -17 185 -25 50 -8 158 -19 240 -25 83
-6 170 -13 195 -16 25 -3 115 -7 200 -9 85 -3 249 -10 364 -16 115 -6 239 -8
275 -5 36 4 183 11 326 16 278 11 629 35 735 51 36 5 121 16 190 24 69 8 148
20 175 26 28 5 68 12 90 14 69 6 299 46 320 55 11 5 38 11 60 14 22 3 58 10
80 15 22 5 96 21 165 36 174 38 181 40 310 73 398 104 627 176 1055 331 55 20
348 136 380 150 11 5 46 21 77 35 31 14 59 26 61 26 3 0 48 20 101 45 53 25
99 45 101 45 17 0 556 276 668 342 26 15 50 28 53 28 3 0 18 8 32 19 15 10 50
31 77 46 113 64 146 83 265 158 307 193 448 289 740 506 180 134 547 433 670
546 25 23 79 72 120 110 416 379 895 905 1220 1340 41 55 79 104 83 110 4 5
31 42 58 80 28 39 57 79 65 90 62 85 97 137 173 250 47 72 88 135 90 140 2 6
7 12 10 15 4 3 16 21 28 40 11 19 73 122 137 228 64 106 116 195 116 197 0 2
15 30 34 62 100 172 275 518 415 826 17 37 31 70 31 72 0 2 11 28 25 57 13 29
43 100 65 158 23 58 48 119 55 135 7 17 34 89 60 160 26 72 51 139 56 150 4
11 20 56 35 100 14 44 30 89 34 100 10 23 60 183 85 270 9 33 21 69 25 80 4
11 25 83 45 160 20 77 41 153 46 169 5 16 9 40 9 52 0 13 5 24 10 24 6 0 10 8
10 18 0 10 14 81 31 158 17 76 40 180 51 229 23 105 65 340 74 405 3 25 9 63
15 85 5 22 16 94 24 160 8 66 19 147 24 180 15 86 42 390 47 530 3 66 9 144
15 173 14 72 14 1012 0 1084 -6 29 -13 112 -16 183 -7 171 -31 437 -50 550 -8
50 -19 135 -25 190 -7 55 -16 111 -20 125 -5 14 -12 50 -14 80 -7 70 -42 274
-55 320 -5 19 -26 109 -45 200 -66 303 -57 266 -154 622 -10 37 -21 71 -25 74
-4 4 -7 15 -7 25 0 21 -141 464 -170 534 -4 11 -24 65 -45 120 -44 118 -139
361 -168 425 -10 25 -30 69 -43 98 -13 29 -24 54 -24 56 0 2 -17 42 -39 88
-21 45 -49 106 -61 133 -99 221 -292 584 -460 865 -51 85 -100 168 -109 183
-30 53 -317 481 -386 577 -74 103 -233 312 -303 400 -25 30 -59 73 -76 94 -40
51 -268 317 -322 376 -22 25 -70 77 -105 115 -92 102 -447 454 -569 566 -141
129 -366 325 -465 404 -28 21 -52 42 -55 45 -26 29 -423 325 -585 437 -207
142 -471 313 -483 313 -6 0 -12 3 -14 8 -4 9 -119 78 -278 167 -25 14 -58 34
-75 43 -79 47 -635 332 -648 332 -3 0 -56 25 -120 55 -63 30 -118 55 -122 55
-3 0 -31 11 -61 25 -30 14 -57 25 -59 25 -2 0 -28 11 -57 24 -61 28 -364 146
-373 146 -4 0 -21 6 -38 14 -18 8 -95 36 -172 61 -77 26 -149 50 -160 55 -11
4 -36 12 -55 18 -99 30 -282 86 -335 102 -33 10 -89 26 -125 34 -68 17 -107
27 -175 45 -114 30 -286 70 -330 76 -27 4 -54 11 -60 15 -5 4 -28 10 -50 13
-22 2 -105 17 -185 32 -240 45 -371 66 -455 74 -44 5 -87 11 -95 14 -8 3 -91
13 -185 21 -93 9 -201 20 -240 26 -86 12 -201 18 -560 30 -304 10 -395 10
-705 0z m-1005 -2269 c40 -19 81 -51 123 -94 68 -71 90 -113 96 -179 l4 -43
60 -6 c77 -7 128 -38 214 -127 82 -85 108 -136 108 -217 0 -94 -24 -133 -167
-277 l-126 -126 -404 404 -405 404 118 116 c180 176 255 205 379 145z m115
-1023 c21 -36 25 -56 25 -118 0 -63 -4 -82 -27 -120 -33 -57 -80 -102 -138
-132 -62 -32 -157 -32 -221 1 -32 16 -150 127 -378 355 l-331 331 69 69 69 68
315 -315 c174 -174 325 -321 336 -326 56 -30 111 3 111 67 0 35 -15 52 -326
362 l-325 325 69 67 69 67 329 -330 c181 -181 340 -348 354 -371z m-1065 147
c53 -16 108 -50 145 -90 l23 -24 -49 -76 c-27 -41 -53 -75 -57 -75 -5 0 -29
18 -54 40 -53 47 -94 52 -130 18 -33 -31 -29 -68 12 -111 45 -47 85 -57 225
-57 152 0 276 -15 347 -42 70 -26 155 -107 185 -177 28 -65 21 -171 -15 -234
-62 -104 -175 -166 -284 -153 -73 9 -118 33 -194 106 -51 49 -61 63 -49 71 8
5 46 28 83 51 l68 41 28 -27 c61 -58 141 -63 175 -11 37 56 3 129 -71 154 -22
8 -124 16 -248 21 -196 7 -214 9 -268 33 -71 32 -157 116 -186 181 -24 56 -28
141 -7 189 31 73 106 143 184 172 49 18 77 18 137 0z m2464 -144 c7 -5 481
-476 1052 -1047 753 -753 1039 -1044 1039 -1061 0 -30 -20 -34 -131 -28 l-93
5 -955 955 c-561 561 -960 954 -968 951 -7 -3 -13 -12 -13 -21 0 -8 -5 -15
-11 -15 -6 0 -1605 -1595 -3554 -3544 l-3544 -3544 86 -86 c47 -47 90 -86 94
-86 4 0 9 -5 11 -10 2 -6 407 -414 901 -908 l897 -898 0 -95 c0 -103 -6 -139
-23 -139 -9 0 -857 838 -1092 1080 -30 30 -155 156 -280 280 -460 458 -710
711 -713 720 -2 6 -8 10 -12 10 -5 0 -27 19 -49 43 -48 50 -61 96 -37 132 23
34 2025 2035 2037 2035 5 0 9 4 9 9 0 7 5156 5168 5255 5261 13 12 76 12 94 1z
m-2843 -434 c256 -183 285 -204 309 -221 17 -12 151 -108 290 -208 22 -16 61
-43 87 -61 l48 -32 -72 -72 c-43 -44 -76 -69 -82 -64 -135 101 -177 131 -188
131 -8 0 -33 -19 -56 -43 -40 -41 -53 -79 -32 -92 5 -3 35 -42 66 -86 l57 -81
-68 -68 -69 -69 -30 42 c-17 23 -33 44 -36 47 -3 3 -21 28 -40 55 -19 28 -38
55 -43 60 -4 6 -69 96 -143 200 -74 105 -151 213 -171 240 -20 28 -50 68 -65
90 -16 22 -56 78 -89 124 l-60 83 83 83 c46 46 88 84 94 84 6 1 101 -63 210
-142z m-425 -124 c7 -16 29 -50 47 -77 l33 -50 -76 -76 -75 -76 336 -337 337
-337 -64 -69 c-35 -38 -68 -68 -72 -67 -4 1 -158 152 -343 336 l-334 334 -88
-87 c-48 -48 -90 -87 -94 -87 -3 0 -21 24 -39 53 -18 28 -36 54 -40 57 -3 3
-10 14 -16 24 -10 18 16 47 221 252 127 128 236 233 242 233 6 1 17 -11 25
-26z m4043 -768 c427 -427 776 -781 776 -789 0 -27 -29 -39 -81 -34 -48 5 -55
9 -144 99 -52 52 -99 95 -105 97 -5 2 -10 7 -10 11 0 4 -90 97 -201 206 -110
110 -230 231 -267 268 -177 180 -753 752 -761 755 -12 4 -6661 -6645 -6661
-6661 0 -8 30 -43 68 -79 37 -36 92 -92 123 -124 31 -33 125 -128 210 -211 85
-84 364 -363 621 -621 l468 -468 0 -44 c0 -58 -9 -90 -25 -90 -7 0 -376 363
-819 807 -728 728 -807 809 -804 835 2 23 661 686 3398 3423 2391 2391 3401
3395 3416 3395 15 0 257 -235 798 -775z m-4528 154 c27 -18 51 -35 54 -38 3
-4 13 -10 22 -16 9 -5 155 -110 325 -232 169 -122 336 -242 370 -266 l62 -44
-72 -71 -72 -72 -42 33 c-24 17 -65 49 -92 70 -27 20 -55 37 -63 37 -8 0 -36
-22 -62 -49 l-49 -50 73 -101 73 -102 -69 -69 -69 -69 -17 22 c-10 13 -39 55
-65 93 -26 39 -51 75 -55 80 -30 38 -224 306 -377 523 -36 51 -87 122 -113
157 l-47 63 87 90 87 90 31 -23 c16 -13 52 -38 80 -56z m-340 -390 c38 -17
104 -76 283 -253 128 -127 250 -256 270 -286 34 -52 36 -60 36 -135 0 -59 -5
-89 -19 -115 -19 -36 -243 -270 -258 -270 -5 0 -189 180 -409 400 l-400 400
118 116 c78 78 135 125 168 140 65 31 145 32 211 3z m-96 -1474 l-70 -70 -404
404 -404 404 70 70 70 69 404 -404 403 -403 -69 -70z m-852 539 c28 -14 72
-46 96 -71 l45 -45 -27 -42 c-14 -22 -38 -57 -51 -76 -14 -19 -26 -37 -28 -39
-1 -2 -28 19 -58 48 -55 49 -68 56 -110 51 -24 -2 -61 -35 -67 -58 -12 -47 15
-81 250 -314 226 -226 240 -238 275 -238 51 0 87 35 87 86 0 32 -10 46 -82
120 -45 46 -87 84 -94 84 -7 0 -25 -16 -41 -36 l-29 -37 -47 80 c-26 44 -47
84 -47 89 0 5 39 48 86 95 l87 87 160 -161 c167 -169 191 -204 203 -295 12
-97 -61 -218 -167 -277 -71 -39 -160 -42 -233 -7 -74 35 -547 510 -581 584
-55 119 -14 253 105 340 87 64 181 75 268 32z m7329 -15 c16 -16 2 -49 -52
-115 -26 -31 -63 -82 -83 -113 -20 -31 -40 -58 -43 -61 -4 -3 -28 -34 -54 -69
-26 -36 -56 -74 -66 -85 -10 -11 -21 -28 -25 -38 -3 -10 -10 -18 -15 -18 -5 0
-9 -7 -9 -15 0 -8 -4 -15 -9 -15 -5 0 -20 -17 -32 -37 -13 -21 -26 -40 -29
-43 -4 -3 -44 -57 -90 -120 -46 -63 -86 -117 -90 -120 -3 -3 -16 -22 -29 -42
-12 -21 -26 -38 -29 -38 -4 0 -20 -21 -36 -47 -17 -25 -40 -57 -53 -71 l-24
-26 1 -1358 c1 -746 -1 -1362 -5 -1368 -3 -5 -14 -10 -24 -10 -10 0 -24 -7
-31 -15 -7 -8 -17 -15 -22 -15 -5 0 -35 -12 -66 -26 -31 -14 -70 -32 -87 -39
-16 -7 -55 -25 -85 -39 -30 -14 -60 -26 -66 -26 -6 0 -32 -11 -58 -25 -26 -14
-53 -25 -60 -25 -8 0 -19 -7 -26 -15 -7 -8 -21 -15 -31 -15 -11 0 -37 -11 -59
-25 -22 -14 -48 -25 -59 -25 -10 0 -24 -7 -31 -15 -7 -8 -21 -15 -31 -15 -10
0 -39 -11 -65 -25 -26 -14 -55 -25 -64 -25 -10 0 -23 -7 -30 -15 -7 -8 -18
-15 -25 -15 -12 0 -75 -29 -147 -66 -14 -8 -36 -14 -47 -14 -12 0 -21 -4 -21
-10 0 -5 -5 -10 -12 -10 -6 0 -39 -13 -72 -29 -115 -54 -177 -81 -184 -81 -4
0 -32 -12 -62 -26 -30 -14 -68 -32 -85 -39 -16 -7 -57 -25 -90 -40 -33 -15
-73 -33 -90 -40 -16 -7 -41 -17 -55 -23 -14 -6 -43 -18 -65 -27 -66 -28 -96
-41 -190 -86 -49 -23 -106 -42 -125 -43 l-35 -1 0 790 c1 1129 15 3836 21
3863 4 22 6 22 192 22 103 0 304 7 447 15 143 8 398 15 566 15 169 0 351 4
405 10 55 5 314 14 578 19 263 5 481 12 484 15 11 11 268 6 279 -5z m-3342
-120 c9 -14 6 -2957 -4 -3405 -8 -356 -8 -362 -32 -400 -13 -22 -29 -45 -37
-53 -8 -8 -17 -24 -22 -35 -4 -12 -50 -85 -101 -163 -99 -149 -147 -224 -164
-251 -5 -10 -12 -19 -15 -22 -3 -3 -10 -14 -17 -25 -6 -11 -36 -57 -65 -103
-29 -46 -58 -91 -63 -100 -6 -9 -37 -57 -70 -107 -33 -49 -62 -94 -64 -100 -4
-9 -78 -123 -132 -203 -16 -23 -29 -45 -29 -49 0 -3 -11 -21 -25 -39 -14 -18
-25 -35 -25 -39 0 -3 -18 -30 -40 -60 -22 -30 -40 -57 -40 -61 0 -4 -11 -22
-25 -40 -14 -18 -25 -36 -25 -39 0 -3 -11 -21 -25 -39 -14 -18 -25 -36 -25
-39 0 -3 -20 -35 -45 -71 -25 -37 -45 -70 -45 -74 0 -5 -9 -17 -19 -29 -11
-11 -29 -39 -40 -62 -12 -22 -26 -41 -31 -41 -6 0 -10 -5 -10 -12 0 -6 -11
-26 -25 -44 -14 -18 -25 -36 -25 -39 0 -3 -10 -21 -23 -38 -12 -18 -28 -41
-34 -52 -7 -11 -35 -56 -63 -100 -28 -44 -57 -89 -63 -100 -7 -10 -18 -26 -26
-34 -8 -8 -20 -29 -27 -46 -7 -17 -22 -39 -33 -49 -12 -11 -21 -23 -21 -28 0
-5 -9 -21 -19 -36 -28 -39 -135 -205 -141 -217 -3 -5 -22 -36 -43 -67 -20 -31
-37 -60 -37 -64 0 -3 -13 -23 -30 -44 -16 -21 -30 -40 -30 -44 0 -3 -29 -49
-65 -101 -36 -53 -65 -99 -65 -102 0 -3 -10 -20 -23 -37 -13 -17 -26 -39 -30
-48 -3 -10 -11 -18 -17 -18 -5 0 -10 -5 -10 -12 0 -6 -11 -26 -25 -44 -14 -18
-25 -37 -25 -42 0 -6 -3 -12 -8 -14 -4 -1 -30 -39 -57 -83 -27 -44 -59 -94
-72 -111 -13 -17 -23 -36 -23 -42 0 -6 -3 -12 -7 -14 -11 -5 -73 -97 -73 -108
0 -6 -4 -10 -10 -10 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -9 -20 -6 0 -16 -11
-23 -24 -7 -14 -53 -88 -103 -166 -49 -78 -95 -149 -100 -159 -6 -9 -37 -56
-70 -106 -33 -49 -64 -98 -70 -107 -37 -63 -114 -181 -147 -225 -21 -29 -38
-55 -38 -59 0 -6 -68 -114 -111 -176 -11 -15 -19 -29 -19 -32 0 -5 -60 -96
-70 -106 -3 -3 -14 -21 -24 -40 -11 -19 -30 -46 -43 -60 -13 -14 -23 -29 -23
-34 0 -4 -18 -35 -40 -68 -22 -33 -40 -63 -40 -66 0 -3 -11 -20 -25 -38 -14
-18 -25 -35 -25 -37 0 -7 -82 -130 -97 -145 -7 -7 -13 -17 -13 -22 0 -5 -31
-56 -68 -112 -38 -57 -90 -136 -116 -176 -49 -76 -72 -95 -87 -71 -5 8 -9 826
-9 1900 0 1885 0 1886 20 1909 12 13 35 49 52 80 28 48 77 121 108 157 5 7 10
15 10 19 0 4 11 21 24 38 12 17 31 47 41 66 10 19 21 37 24 40 4 3 29 40 55
83 26 42 52 77 57 77 5 0 9 6 9 14 0 8 25 50 55 95 30 45 55 85 55 90 0 5 3
11 8 13 11 5 92 126 92 138 0 5 5 10 10 10 6 0 15 12 21 28 11 29 54 95 82
126 9 11 17 23 17 27 0 4 24 43 53 86 30 44 56 87 60 96 3 9 11 17 17 17 5 0
10 5 10 11 0 6 10 25 23 42 12 18 30 48 41 67 10 19 22 37 25 40 4 3 33 48 66
100 33 52 62 97 65 100 3 3 21 30 40 60 19 30 37 57 40 60 4 3 10 12 14 20 13
28 105 170 117 180 3 3 9 12 13 20 13 28 51 86 248 383 54 82 98 151 98 154 0
4 11 21 25 39 14 18 25 35 25 39 0 3 17 29 38 58 34 47 170 258 198 308 6 11
20 30 31 42 11 12 23 29 27 37 10 21 23 43 94 149 34 52 62 97 62 100 1 3 28
44 61 91 32 47 64 97 70 113 6 15 15 27 20 27 5 0 9 6 9 14 0 8 3 16 8 18 10
4 72 96 72 107 0 4 10 19 23 33 12 14 31 41 41 61 11 21 23 37 28 37 4 0 8 6
8 13 0 8 10 26 23 40 12 15 31 43 42 64 10 21 32 54 47 74 15 20 28 42 28 48
0 6 5 11 10 11 6 0 10 7 10 15 0 9 7 18 15 21 8 4 15 13 15 20 0 8 6 22 13 30
28 33 33 41 51 74 11 19 22 37 25 40 11 9 61 89 61 98 0 4 13 23 30 42 16 19
29 38 30 42 0 7 59 99 69 108 4 3 15 22 25 43 11 20 23 37 28 37 4 0 8 4 8 9
0 5 25 46 55 91 30 45 55 85 55 90 0 5 4 10 8 12 4 2 19 21 32 43 51 86 170
262 184 275 9 7 16 19 16 26 0 8 23 45 50 84 28 39 50 72 50 74 0 2 25 41 55
86 30 45 55 83 55 85 0 4 44 73 58 90 4 6 18 28 31 50 43 71 62 87 76 64z
m4925 -1234 c635 -636 1223 -1223 1305 -1305 869 -865 2121 -2123 2127 -2137
3 -10 7 -33 7 -51 1 -30 -86 -119 -1174 -1207 -647 -646 -1179 -1175 -1184
-1175 -15 0 -21 41 -21 136 0 77 3 95 20 117 12 14 495 500 1074 1080 777 778
1052 1058 1045 1068 -7 13 -4273 4282 -4352 4356 -39 37 -47 65 -47 174 0 64
3 80 18 88 9 6 19 11 22 11 3 0 525 -520 1160 -1155z m-8729 162 c-36 -37 -69
-66 -74 -64 -14 4 -797 790 -797 800 0 5 29 38 65 72 l65 64 403 -402 404
-402 -66 -68z m9534 -1523 c1152 -1153 2102 -2106 2110 -2117 8 -12 15 -28 15
-35 0 -8 -415 -429 -921 -935 -854 -854 -922 -920 -935 -902 -8 10 -14 42 -14
72 l0 53 628 625 c345 344 632 630 637 636 6 6 110 111 232 233 l223 223 -276
274 c-151 151 -298 298 -327 328 -29 29 -123 124 -211 210 -87 86 -163 161
-170 168 -6 6 -721 722 -1588 1590 -1242 1243 -1578 1585 -1578 1604 0 35 27
69 55 69 19 0 498 -474 2120 -2096z m-10320 1686 c181 -181 335 -330 341 -330
6 0 56 45 111 100 l100 100 57 -81 c32 -44 56 -81 54 -82 -2 -1 -77 -74 -166
-162 l-162 -160 -400 400 c-220 220 -400 403 -400 407 0 7 122 136 130 137 3
1 154 -147 335 -329z m-478 -472 c367 -368 372 -376 373 -490 0 -37 -4 -69 -9
-72 -5 -3 -12 -18 -16 -33 -3 -16 -32 -53 -63 -83 -64 -63 -145 -96 -210 -87
-90 12 -124 39 -464 378 -180 180 -328 332 -328 336 0 5 29 38 65 73 l65 65
328 -328 c359 -358 356 -356 415 -302 30 29 34 60 12 91 -8 12 -154 161 -325
331 -170 171 -310 315 -310 319 0 9 121 134 130 134 3 0 155 -150 337 -332z
m-365 -519 l401 -401 -75 -75 -74 -74 -150 76 c-82 43 -193 100 -246 127 -53
28 -102 48 -108 46 -6 -2 75 -88 179 -193 l190 -189 -52 -56 c-28 -31 -60 -61
-69 -68 -15 -10 -70 41 -418 388 -220 221 -400 403 -400 406 0 9 138 144 147
144 4 0 80 -38 168 -85 88 -46 195 -101 238 -121 42 -20 77 -41 77 -46 0 -4 5
-8 10 -8 28 0 -6 41 -177 212 l-186 186 64 65 c35 36 68 66 72 66 4 1 188
-179 409 -400z m-516 -458 c209 -209 390 -391 403 -405 l25 -26 -64 -65 c-36
-36 -67 -65 -70 -65 -4 0 -187 180 -408 400 l-401 401 67 68 c37 38 68 69 68
70 1 1 172 -170 380 -378z m-188 -244 l402 -402 -68 -68 -68 -67 -177 176
c-97 98 -180 175 -183 171 -6 -5 65 -118 203 -326 35 -51 63 -99 63 -105 0 -7
-24 -36 -54 -65 l-55 -54 -53 33 c-29 19 -74 49 -99 67 -26 18 -52 33 -58 33
-6 0 -11 4 -11 8 0 4 -15 16 -32 26 -18 11 -66 41 -106 68 -41 27 -76 47 -80
44 -3 -4 73 -85 168 -181 96 -96 176 -178 177 -182 2 -5 -26 -38 -62 -73 l-65
-65 -405 405 -404 404 81 78 81 79 119 -73 c300 -184 367 -226 420 -261 60
-39 68 -42 68 -29 0 8 -60 111 -111 192 -14 21 -124 196 -181 288 -10 15 -25
41 -34 57 -9 17 -23 38 -31 47 -14 15 -8 24 63 97 44 44 81 80 84 80 3 1 186
-180 408 -402z m-983 -428 c77 -56 156 -112 175 -125 19 -13 49 -34 66 -46
106 -77 347 -250 462 -331 45 -32 83 -62 85 -65 1 -4 -29 -37 -68 -74 l-70
-66 -94 69 c-52 38 -100 69 -106 69 -6 0 -33 -22 -60 -50 l-49 -49 34 -48 c18
-27 51 -70 72 -97 21 -27 38 -52 38 -55 0 -4 -31 -37 -68 -74 l-68 -68 -56 78
c-30 43 -114 160 -185 259 -72 100 -153 212 -179 250 -26 38 -52 74 -56 79 -5
6 -51 70 -104 143 l-96 132 83 84 c46 47 89 85 94 85 6 1 74 -44 150 -100z
m10661 -703 c3 -8 -6 -32 -20 -53 -14 -21 -26 -43 -26 -49 0 -7 -7 -14 -15
-18 -8 -3 -15 -10 -15 -16 0 -6 -18 -38 -40 -71 -22 -33 -40 -62 -40 -65 0 -2
-18 -33 -40 -68 -22 -35 -40 -66 -40 -69 0 -3 -34 -60 -75 -126 -41 -67 -75
-123 -75 -125 0 -3 -18 -32 -40 -65 -22 -33 -40 -62 -40 -65 0 -3 -36 -64 -80
-136 -44 -72 -80 -134 -80 -139 0 -5 -6 -14 -14 -20 -8 -7 -22 -26 -31 -44 -8
-18 -25 -48 -37 -67 -11 -19 -28 -48 -37 -65 -9 -16 -33 -55 -52 -85 -20 -31
-48 -76 -62 -100 -15 -25 -36 -61 -47 -80 -11 -19 -34 -57 -51 -85 -16 -27
-34 -60 -39 -72 -5 -13 -33 -33 -67 -48 -32 -15 -82 -38 -111 -51 -29 -13 -57
-24 -61 -24 -5 0 -22 -6 -38 -14 -15 -8 -41 -20 -58 -26 -50 -20 -99 -42 -127
-56 -14 -8 -33 -14 -42 -14 -9 0 -16 -4 -16 -10 0 -5 -7 -10 -15 -10 -15 0
-54 -16 -140 -56 -28 -13 -58 -24 -66 -24 -9 0 -22 -7 -29 -15 -7 -8 -23 -15
-36 -15 -13 0 -24 -4 -24 -10 0 -5 -7 -10 -16 -10 -9 0 -28 -6 -42 -14 -26
-13 -66 -31 -122 -54 -96 -40 -122 -51 -223 -96 -32 -14 -64 -26 -72 -26 -7 0
-16 -4 -19 -9 -3 -4 -34 -19 -68 -31 -35 -13 -67 -27 -72 -32 -6 -4 -18 -8
-28 -8 -10 0 -18 -3 -18 -7 0 -5 -21 -16 -48 -26 -26 -10 -60 -24 -77 -32 -16
-7 -48 -20 -70 -30 -75 -31 -126 -53 -207 -89 -31 -15 -61 -26 -66 -26 -5 0
-34 -13 -65 -30 -31 -16 -66 -30 -77 -30 -11 0 -20 -4 -20 -10 0 -5 -6 -10
-14 -10 -8 0 -54 -18 -101 -40 -47 -22 -95 -40 -106 -40 -10 0 -19 -4 -19 -10
0 -5 -5 -10 -11 -10 -6 0 -27 -7 -47 -16 -21 -9 -50 -22 -67 -29 -16 -8 -56
-25 -88 -39 -32 -14 -61 -26 -64 -26 -4 0 -26 -9 -50 -20 -24 -11 -62 -29 -86
-40 -24 -11 -51 -20 -60 -20 -9 0 -17 -4 -17 -10 0 -5 -5 -10 -11 -10 -5 0
-31 -9 -57 -21 -98 -42 -130 -56 -187 -79 -44 -18 -82 -34 -148 -64 -32 -14
-64 -26 -71 -26 -7 0 -19 -7 -26 -15 -7 -8 -19 -15 -26 -15 -13 0 -98 -35
-157 -66 -16 -8 -37 -14 -48 -14 -10 0 -19 -4 -19 -9 0 -5 -10 -12 -22 -16
-28 -8 -64 -23 -100 -41 -14 -8 -33 -14 -42 -14 -9 0 -16 -4 -16 -10 0 -5 -10
-10 -23 -10 -13 0 -27 -4 -33 -9 -5 -5 -34 -19 -64 -31 -30 -12 -64 -26 -75
-30 -11 -5 -27 -11 -35 -14 -8 -3 -22 -10 -30 -14 -74 -41 -113 -52 -124 -33
-7 11 19 77 34 86 5 3 62 84 125 180 64 97 123 182 131 189 8 8 14 19 14 25 0
5 6 16 14 24 8 7 28 37 46 65 17 29 36 52 41 52 5 0 9 4 9 9 0 8 92 154 117
186 5 6 33 48 64 95 53 80 81 123 104 158 6 8 20 26 33 40 12 14 22 29 22 34
0 5 11 24 25 42 14 18 25 37 25 42 0 5 12 20 26 34 15 13 29 31 33 40 9 23
220 332 284 415 16 22 91 65 113 65 5 0 31 11 59 24 65 31 184 86 210 95 11 5
49 22 85 39 36 18 73 32 83 32 9 0 17 5 17 10 0 6 11 10 24 10 13 0 29 7 36
15 7 8 18 15 25 15 8 0 28 8 47 17 60 30 68 33 82 33 7 0 19 7 26 15 7 8 20
15 29 15 8 0 38 11 66 24 54 26 175 81 215 98 62 26 89 38 145 64 33 15 74 32
90 39 17 7 41 17 55 23 14 5 32 13 40 16 8 3 22 10 30 15 8 5 26 13 40 19 14
6 43 18 65 27 119 50 180 79 183 88 2 4 10 7 17 7 14 0 35 8 145 57 69 31 105
47 150 66 19 8 60 27 91 41 31 14 63 26 72 26 10 0 17 3 17 8 0 4 21 15 48 26
26 10 74 31 107 46 33 15 78 35 100 45 113 48 161 70 245 108 30 13 65 27 78
31 12 4 22 12 22 17 0 5 14 9 30 9 17 0 30 5 30 10 0 6 5 10 11 10 11 0 25 6
144 60 33 15 78 35 100 45 119 51 166 72 248 109 32 14 64 26 71 26 7 0 19 7
26 15 7 8 20 15 29 15 8 0 38 11 66 24 27 13 57 27 65 30 8 3 22 10 30 15 8 5
33 17 55 26 22 9 49 20 60 25 11 4 38 15 60 24 22 10 51 23 65 31 32 19 79 19
86 1z m-995 -2186 c19 -10 19 -32 19 -960 l0 -950 358 6 c196 3 398 9 449 15
51 5 231 9 400 9 169 1 342 5 383 10 41 5 166 13 277 16 l203 7 282 288 c319
324 391 400 414 435 9 13 22 24 29 24 7 0 19 10 28 23 25 37 179 187 193 187
7 0 18 -8 23 -18 11 -20 6 -850 -6 -932 -3 -25 -9 -431 -12 -902 -5 -783 -7
-859 -23 -874 -15 -16 -203 -17 -2594 -22 -2493 -5 -2578 -4 -2591 13 -11 16
-13 258 -13 1390 0 1224 2 1373 16 1393 8 12 25 22 36 22 12 0 50 14 85 30 34
17 70 30 77 30 8 0 18 5 21 10 3 6 13 10 22 10 9 0 43 13 77 29 34 15 79 34
101 41 51 16 68 23 135 53 30 14 82 35 115 47 33 12 78 29 100 37 22 8 44 19
50 24 5 5 17 9 27 9 18 0 25 3 86 33 19 9 42 17 52 17 10 0 21 4 24 9 3 4 34
19 68 31 35 13 67 27 73 32 5 4 17 8 27 8 10 0 26 4 36 10 18 9 57 26 132 55
51 19 107 43 132 56 10 5 29 9 42 9 13 0 26 7 30 15 3 8 16 15 29 15 13 0 27
4 33 8 5 5 32 17 59 26 28 10 64 24 80 31 42 19 94 40 135 55 32 11 48 17 120
49 50 21 125 50 133 50 5 1 17 -4 28 -9z m-4699 -2302 c54 -62 242 -248 250
-248 4 0 8 -4 8 -8 0 -7 159 -167 413 -418 7 -7 84 -85 172 -174 88 -89 183
-183 210 -210 28 -26 129 -128 225 -225 96 -97 191 -191 210 -210 19 -18 203
-201 407 -407 946 -948 1280 -1278 1295 -1278 9 0 38 23 65 52 26 29 140 144
253 255 113 111 210 208 215 214 49 55 389 389 396 389 5 0 9 5 9 11 0 9 287
300 351 355 13 11 58 57 100 102 l75 82 67 0 c51 0 69 -4 73 -15 4 -10 -242
-263 -789 -810 -625 -624 -801 -795 -820 -795 -20 0 -368 343 -1656 1631 -896
897 -1633 1640 -1636 1650 -9 26 33 89 59 89 11 0 32 -15 48 -32z m5 -470
c105 -106 202 -203 215 -214 12 -12 466 -466 1008 -1008 542 -543 1019 -1020
1060 -1061 41 -41 253 -252 470 -470 217 -217 398 -395 402 -395 5 0 436 428
959 950 l950 951 116 -3 c77 -2 118 -7 120 -15 4 -12 -1691 -1713 -1707 -1713
-6 0 -10 -4 -10 -9 0 -12 -348 -361 -359 -361 -5 0 -11 -7 -15 -15 -4 -10 -20
-15 -53 -15 l-47 0 -319 318 c-175 174 -324 322 -330 328 -7 7 -139 140 -294
295 -156 156 -373 374 -483 484 -110 109 -200 203 -200 207 0 4 -4 8 -8 8 -4
0 -216 208 -470 463 -254 254 -663 663 -908 908 l-446 446 26 41 c14 23 26 45
26 49 0 4 12 19 26 35 27 27 27 27 53 8 14 -10 112 -106 218 -212z"/>
<path d="M11261 20574 c-22 -20 -41 -41 -41 -48 0 -15 172 -186 187 -186 6 0
25 17 42 37 46 56 42 96 -14 155 -87 91 -111 97 -174 42z"/>
<path d="M11604 20262 c-79 -58 -80 -51 39 -170 l108 -106 44 44 c66 64 63 96
-13 176 -89 94 -114 102 -178 56z"/>
<path d="M10100 19090 c0 -12 161 -230 170 -230 3 0 21 15 39 34 l33 34 -116
86 c-64 47 -118 86 -121 86 -3 0 -5 -5 -5 -10z"/>
<path d="M9290 18280 c0 -9 134 -195 161 -224 10 -11 69 41 69 60 0 12 -32 38
-135 108 -28 19 -57 41 -64 50 -15 18 -31 21 -31 6z"/>
<path d="M8715 18014 c-37 -19 -75 -54 -75 -68 0 -6 119 -130 265 -276 l265
-264 39 38 c46 45 54 75 31 113 -27 42 -452 460 -475 467 -11 3 -33 -1 -50
-10z"/>
<path d="M4820 13825 c0 -4 19 -32 43 -63 24 -32 61 -81 82 -109 22 -29 46
-53 55 -53 18 0 60 40 60 56 -1 9 -200 161 -225 171 -8 3 -15 2 -15 -2z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
